import React, { useState } from 'react';
import '../styles/Classes.css';

const Classes: React.FC = () => {
    const [activeClass, setActiveClass] = useState('assassino');

    const classes = [
        {
            id: 'assassino',
            name: 'Assassino',
            title: 'Mestre das Sombras',
            subtitle: 'Especialista em Ataques Críticos',
            navSubtitle: 'Dano explosivo / furtividade',
            icon: 'ri-sword-fill',
            description:
                'Assassinos surgem das sombras para eliminar seus inimigos em questão de segundos. Com alta mobilidade e golpes críticos, são perfeitos para quem gosta de jogar agressivamente e desaparecer antes da retaliação.',
            stats: { attack: 95, defense: 45, speed: 95 },
            image: '/assets/img/nav_assassin.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'arqueiro',
            name: 'Arqueiro',
            title: 'Guardião das Florestas',
            subtitle: 'Domínio total da longa distância',
            navSubtitle: 'Dano à distância / mobilidade',
            icon: 'ri-aiming-line',
            description:
                'Arqueiros utilizam arcos e bestas para atacar de longe com extrema precisão. Com armadilhas e habilidades de controle, conseguem dominar o campo de batalha mantendo sempre a distância ideal.',
            stats: { attack: 88, defense: 55, speed: 85 },
            image: '/assets/img/nav_ranger.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'mago',
            name: 'Mago',
            title: 'Senhor dos Elementos',
            subtitle: 'Poder arcano devastador',
            navSubtitle: 'Dano em área / controle',
            icon: 'ri-magic-fill',
            description:
                'Magos manipulam fogo, gelo e relâmpagos para destruir grupos inteiros de inimigos. Apesar da defesa frágil, suas magias em área e habilidades de controle tornam-se fundamentais em qualquer grupo.',
            stats: { attack: 98, defense: 40, speed: 70 },
            image: '/assets/img/nav_wizard.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'berserker',
            name: 'Berserker',
            title: 'Guerreiro Imparável',
            subtitle: 'Força bruta em primeira linha',
            navSubtitle: 'Ofensivo / corpo a corpo',
            icon: 'ri-flashlight-fill',
            description:
                'Berserkers mergulham no meio da batalha sem medo, usando armas pesadas para causar enorme dano corpo a corpo. Ideais para jogadores que gostam de estar sempre na linha de frente.',
            stats: { attack: 92, defense: 85, speed: 65 },
            image: '/assets/img/nav_berserker.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'guardian',
            name: 'Guardian',
            title: 'Escudo de Icarus',
            subtitle: 'Defensor absoluto do grupo',
            navSubtitle: 'Tank / proteção',
            icon: 'ri-shield-star-fill',
            description:
                'Guardians dedicam-se a proteger seus aliados, atraindo a atenção dos inimigos e absorvendo grandes quantidades de dano. Sua presença é essencial em qualquer conteúdo desafiador.',
            stats: { attack: 70, defense: 98, speed: 55 },
            image: '/assets/img/nav_guardian.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'trickster',
            name: 'Trickster',
            title: 'Ilusionista Caótico',
            subtitle: 'Controle e confusão',
            navSubtitle: 'Debuff / utilidade',
            icon: 'ri-ghost-fill',
            description:
                'Tricksters usam truques, armadilhas e ilusões para confundir seus inimigos. Com habilidades de debuff e controle, enfraquecem o oponente e criam aberturas para o grupo.',
            stats: { attack: 85, defense: 55, speed: 90 },
            image: '/assets/img/nav_trickster.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'magician',
            name: 'Magician',
            title: 'Arcanista de Suporte',
            subtitle: 'Magia de apoio e controle',
            navSubtitle: 'Buffs / controle de campo',
            icon: 'ri-sparkling-2-fill',
            description:
                'Magicians fortalecem aliados com poderosos buffs e controlam o ritmo da luta com magias de área e efeitos especiais. São perfeitos para quem gosta de jogar de forma estratégica.',
            stats: { attack: 80, defense: 60, speed: 75 },
            image: '/assets/img/nav_magician.jpg',
            statsImage: '/assets/img/stats.jpg'
        },
        {
            id: 'priest',
            name: 'Priest',
            title: 'Guardião da Luz',
            subtitle: 'Cura e proteção',
            navSubtitle: 'Healer / suporte',
            icon: 'ri-heart-pulse-fill',
            description:
                'Priests canalizam o poder da luz para manter o grupo vivo, removendo efeitos negativos e restaurando a vida dos aliados. São a linha final entre a vitória e a derrota.',
            stats: { attack: 70, defense: 75, speed: 70 },
            image: '/assets/img/nav_priest.jpg',
            statsImage: '/assets/img/stats.jpg'
        }
    ];

    const currentClass = classes.find(c => c.id === activeClass) || classes[0];

    return (
        <div className="classes-page">
            {/* Hero / Characters & Classes Section inspirado no site original */}
            <header
                className="class-hero"
                style={{ backgroundImage: `url(${currentClass.image})` }}
            >
                <div className="class-nav-container">
                    <div className="class-nav">
                        {classes.map((classItem) => (
                            <button
                                key={classItem.id}
                                type="button"
                                className={`class-nav-item ${activeClass === classItem.id ? 'active' : ''}`}
                                onClick={() => setActiveClass(classItem.id)}
                            >
                                <div className="nav-icon-wrapper">
                                    <i className={classItem.icon}></i>
                                </div>
                                <div className="nav-content">
                                    <span className="nav-title">{classItem.name.toUpperCase()}</span>
                                    <span className="nav-subtitle">{classItem.navSubtitle}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </header>

            <div className="container">
                <h1 className="page-title">
                    CHOOSE YOUR <span className="highlight">CLASS</span>
                </h1>

                <div className="classes-container">
                    {/* Class Selection (lista lateral) */}
                    <div className="class-selection">
                        {classes.map((classItem) => (
                            <button
                                key={classItem.id}
                                type="button"
                                className={`class-btn ${activeClass === classItem.id ? 'active' : ''}`}
                                onClick={() => setActiveClass(classItem.id)}
                            >
                                <img src={classItem.image} alt={classItem.name} />
                                <h3>{classItem.name}</h3>
                            </button>
                        ))}
                    </div>

                    {/* Class Details */}
                    <div className="class-detail active">
                        <div className="detail-content">
                            <div className="detail-text">
                                <h3>{currentClass.title}</h3>
                                <h4>{currentClass.subtitle}</h4>
                                <p>{currentClass.description}</p>

                                <div className="stats-section">
                                    <h5>Combat Statistics</h5>
                                    <div className="stats-container">
                                        <div className="stat-item">
                                            <span className="stat-label">Attack</span>
                                            <div className="stat-bar">
                                                <div
                                                    className="stat-fill"
                                                    style={{ width: `${currentClass.stats.attack}%` }}
                                                ></div>
                                            </div>
                                            <span className="stat-value">{currentClass.stats.attack}</span>
                                        </div>
                                        <div className="stat-item">
                                            <span className="stat-label">Defense</span>
                                            <div className="stat-bar">
                                                <div
                                                    className="stat-fill"
                                                    style={{ width: `${currentClass.stats.defense}%` }}
                                                ></div>
                                            </div>
                                            <span className="stat-value">{currentClass.stats.defense}</span>
                                        </div>
                                        <div className="stat-item">
                                            <span className="stat-label">Speed</span>
                                            <div className="stat-bar">
                                                <div
                                                    className="stat-fill"
                                                    style={{ width: `${currentClass.stats.speed}%` }}
                                                ></div>
                                            </div>
                                            <span className="stat-value">{currentClass.stats.speed}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="detail-image">
                                <img
                                    src={currentClass.statsImage}
                                    alt={`${currentClass.name} Stats`}
                                    className="stats-graphic"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Classes;
